import { useDebounceCallback } from '@data-products-and-ai/react-components';
import { useState } from 'react';

export const useSearch = () => {
  const [query, setQuery] = useState('');
  const [debouncedQuery, setDebouncedQuery] = useState('');

  const debouncedSetQuery = useDebounceCallback((value: string) => {
    setDebouncedQuery(value);
  }, 500);

  const handleSearch = (value: string) => {
    setQuery(value);
    debouncedSetQuery(value);
  };

  return {
    query,
    debouncedQuery,
    handleSearch,
  };
};
